import React from 'react';
import { Container, Form, InputGroup, Label, Row } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import cx from 'classnames';

// ducks
import { typeahead_golf_course } from '../../ducks/Shared';

// components
import TypeAhead from '../../components/form/field/typeahead';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';

let SearchForm = props => {
  const { handleSubmit } = props;

  return (
    <Row className={cx(styles.searchHeader, BS.pt3)}>
      <Container>
        <Form inline className={cx(BS.alignItemsStart)} onSubmit={handleSubmit}>
          <InputGroup className={cx(BS.inputGroupGutter, BS.pb2)}>
            <Label for="name" className="sr-only">
              Name
            </Label>
            <Field
              name="name"
              type="text"
              placeholder="Name"
              component={TypeAhead}
              labelAsValue
              loadOptions={(search, callback) => typeahead_golf_course(search, callback)}
              showSubmit
              submitClassName={cx(BS.ml2)}
            />
          </InputGroup>
        </Form>
      </Container>
    </Row>
  );
};

const GolfCourseSearchForm = reduxForm({
  form: 'golf-course-search-form'
})(SearchForm);

export default GolfCourseSearchForm;



// WEBPACK FOOTER //
// ./src/containers/GolfCourseSearch/GolfCourseSearchForm.js